import type {ChangeSpec} from '@codemirror/state'
import type {Command} from '@codemirror/view'

import {MarkdownLine} from '../../../language-tools/markdown/markdown-line'
import {isPositionedNode} from '../../../language-tools/syntax-tree/positioned-node'
import {getMarkdownTree} from '../../extensions/markdown-parser'
import {getListSelection, positionedItems} from './utils'

function getListPrefixAtDepth(line: MarkdownLine, depth: number) {
  for (const prefix of line.prefixes) {
    if (prefix.tokenType === 'listItemIndent' || prefix.tokenType === 'listItemPrefix') {
      if (depth === 0) return prefix
      depth--
    }
  }
}

/**
 * Generate changes to remove a list, handling cases where the list is a nested list or has a nested list in it.
 * Operates on the lowest list that fully contains the selection.
 */
export const removeList: Command = view => {
  const tree = getMarkdownTree(view.state)
  const doc = view.state.doc.toString()
  const selection = getListSelection(view.state)
  if (!selection) return false
  const depth = selection.parents.length

  const changes: ChangeSpec[] = []

  for (const item of positionedItems(selection.list.children))
    for (const line of MarkdownLine.linesAtRange(tree, doc, item.position.start.offset, item.position.end.offset - 1)) {
      const prefix = getListPrefixAtDepth(line, depth)
      if (!prefix || !isPositionedNode(prefix)) continue
      changes.push({
        from: prefix.position.start.offset,
        to: prefix.position.end.offset,
      })
    }

  if (changes.length) {
    view.dispatch({changes, userEvent: 'input', scrollIntoView: true})
    return true
  }

  return false
}
